module.exports = __webpack_public_path__ + "img/logo_white.178b2135.png";